module.exports = __webpack_public_path__ + "media/images/setting/icon2-fe23835ca1dd9e12f023272ca241f7b8.svg";